import React from 'react';
import Review from 'shared/components/review';
import { ReactComponent as CLARA } from '../../../../assets/icons/CLARA.svg';
import { ClaraLoginReviewContainer, ClaraLoginReviewImage, HomepageTypography } from './index.styles';
import { ScrollableBox } from 'features/auth/container/authLayout/index.styles';
import { Box } from '@mui/material';
import { StaticReview } from 'features/auth/utilites';

export default function ClaraLoginReview() {

    return (
        <ClaraLoginReviewContainer>
            <ClaraLoginReviewImage>
                <CLARA />
                <HomepageTypography
                    sx={{
                        fontSize: "36px",
                        fontWeight: "700",
                        mt: "1rem",
                        lineHeight:'41px',
                        mb: "1rem",
                    }}
                >
                    See <span className='em'>Reviews & Pricing</span>
                    <br />
                    Insights for Top Brands
                </HomepageTypography>
            </ClaraLoginReviewImage>
            <ScrollableBox>
            {StaticReview.map((review) => (
                <Box marginBottom='12px' key={review._id}>
                    <Review
                        isStaticCard
                        brandName={review.brandName}
                        imageUrl={review.brandLogo}
                        socialMedia={review.project}
                        review={review.review}
                        reviewPostDate={review.createdAt}
                        rating={review.rating}
                    />
                </Box>
            ))}
                </ScrollableBox>
        </ClaraLoginReviewContainer>
    );
}
